import React from "react"
import Styles from "./Info.module.css"
import { useAppSelector } from "../../app/hooks"
import Sok from "../shared/Søk.svg?react"

export default function Info(): React.ReactElement {
  const { isMobile } = useAppSelector((state) => state.setting)

  return (
    <div className={Styles.info}>
      <div>{isMobile ? <Sok /> : null}</div>
      <h2>Finner du ikke en passende konto?</h2>
      <p>
        Om du ikke finner en passende konto, så prøv å finn noe som ligner. Det aller viktigste i et regnskap er at
        totale inntekter og utgifter stemmer!
      </p>
    </div>
  )
}
